import { render, staticRenderFns } from "./DemoIntegratie.vue?vue&type=template&id=7c77d090&"
import script from "./DemoIntegratie.vue?vue&type=script&lang=js&"
export * from "./DemoIntegratie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports